import type { CommonProperty } from '@/modules/health/rater/models/DXP/ConfigurationsProperties'

export class PetConfigTypes {
  dog: CommonProperty
  cat: CommonProperty

  constructor(data: any = {}) {
    this.dog = data.dog
    this.cat = data.cat
  }
}
